import { createReducer, on } from '@ngrx/store';
import * as fromActions from '../actions';

export interface CandidateDetailsState {
    clinicalTracksChanged: boolean;
}

export const initialCandidateDetailsState: CandidateDetailsState = {
    clinicalTracksChanged: false
};

export const candidateDetailsReducer = createReducer<CandidateDetailsState>(
    initialCandidateDetailsState,
    on(fromActions.RecruitingActions.CandidateDetailsActions.changeClinicalTracks, (state, action) => ({
        ...state,
        clinicalTracksChanged: action.clinicalTracksChanged
    }))
);
